import {useCallback, useContext, useEffect, useState} from 'react';
import Link from '../../common/link/Link';
import {showSuccessToast} from '../../common/toasts/utils';
import {deleteLunchOrder, getLunchOrders, updateLunchOrder} from "../../../utils/api/lunchOrders";

import './HomePage.scss';
import EmptyPlaceholderPage from "../emptyPlaceholder/EmptyPlaceholderPage";
import EditOrderModal from "./editOrder/EditOrderModal";
import DeleteOrderModal from "./deleteOrder/DeleteOrderModal";
import UserOrdersTable from "./userOrders/UserOrdersTable";
import Button from "../../common/button/Button";
import {exportOrdersToFile} from "../../../utils/export";
import * as supportedExtensions from "../../../constants/supportedExtensions";
import {OfficeContext} from "../../../state/OfficeContext";

const HomePage = () => {
    const [lunch, setLunch] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const [deleteItem, setDeleteItem] = useState(null);
    const {offices, selectedOffice} = useContext(OfficeContext);
    const fetchLunchOrders = useCallback((token) => getLunchOrders(setLunch, token), []);

    useEffect(() => {
        fetchLunchOrders();
    }, [fetchLunchOrders, selectedOffice]);

    const handleDeleteRowSuccess = () => {
        showSuccessToast([`Yey! Successfully deleted the order!`]);
        setDeleteItem(null);
        fetchLunchOrders();
    };
    const handleDeleteRow = async () => {
        await deleteLunchOrder(lunch.id, deleteItem.id, handleDeleteRowSuccess)
    }
    const handleUpdateOrderSuccess = () => {
        showSuccessToast([`Yey! Successfully updated the order!`]);
        setEditItem(null);
        fetchLunchOrders();
    }
    const handleEditRow = async () => {
        const order = {
            dishes: [editItem.dish],
            additionalInfo: editItem.additionalInfo,
        };
        await updateLunchOrder(lunch.id, editItem.id, order, handleUpdateOrderSuccess);
    }
    const handleCloseDeleteModal = () => {
        setDeleteItem(null);
    };
    const handleCloseEditModal = () => {
        setEditItem(null);
    };
    const handleExportClick = (extension) => {
        exportOrdersToFile(offices[selectedOffice], lunch.title, extension, orders, options);
    }
    const {orders, options} = lunch || {};
    return !lunch ? <EmptyPlaceholderPage/> : (
        <div className="home-page page">
            <p className="page-header">Lunch information</p>
            <div className="home-page__subtitle">
                <div className="home-page__lunch-info">
                    <Link url={lunch.companyUrl} text={lunch.company}/>
                    <p>{lunch.title}</p>
                </div>
                <div className="home-page__export-section">
                    <div className="home-page__export">Export:</div>
                    {Object.keys(supportedExtensions).map((label) => (
                        <Button
                            key={label}
                            label={label}
                            onClick={() => handleExportClick(supportedExtensions[label])}
                        />
                    ))}
                </div>
            </div>
            <UserOrdersTable
                orders={orders}
                options={options}
                onEditOrder={setEditItem}
                onRemoveOrder={setDeleteItem}
            />
            {editItem &&
            <EditOrderModal
                options={options}
                userOrder={editItem}
                onClose={handleCloseEditModal}
                onChange={setEditItem}
                onSubmit={handleEditRow}
            />
            }
            {deleteItem &&
            <DeleteOrderModal
                onDelete={handleDeleteRow}
                onClose={handleCloseDeleteModal}
            />
            }
        </div>
    );
}

export default HomePage;
